var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 64.1668C51.1087 64.1668 64.1666 51.1089 64.1666 35.0002C64.1666 18.8914 51.1087 5.8335 34.9999 5.8335C18.8912 5.8335 5.83325 18.8914 5.83325 35.0002C5.83325 51.1089 18.8912 64.1668 34.9999 64.1668Z",
    stroke: "#090057",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 33.5418C36.9338 33.5418 38.7885 32.7736 40.1559 31.4061C41.5234 30.0387 42.2916 28.184 42.2916 26.2502C42.2916 24.3163 41.5234 22.4616 40.1559 21.0942C38.7885 19.7267 36.9338 18.9585 34.9999 18.9585C33.066 18.9585 31.2114 19.7267 29.8439 21.0942C28.4765 22.4616 27.7083 24.3163 27.7083 26.2502C27.7083 28.184 28.4765 30.0387 29.8439 31.4061C31.2114 32.7736 33.066 33.5418 34.9999 33.5418Z",
    stroke: "#090057",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6152 55.9012C15.1169 48.3018 21.4402 42.292 29.1665 42.292H40.8331C48.5492 42.292 54.8667 48.2857 55.3829 55.8705",
    stroke: "#090057",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.bf70267912c5f5723059b7d563596e24.svg";
export { ForwardRef as ReactComponent };